const addProductToCart = require('./product/addToCart');
const page = require('../page');
const login = require('../login');
const productUtil = require('./product/productUtil');
const util = require('../util');

exports.init = () => {
    addProductToCart();
    $('#editAddress').on('change', (event) => {
        page.redirect(util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(event.currentTarget).val()));
    });

    // add js logic to remove the , from the qty feild to pass regex expression on client side
    $('.option-quantity-desired input').on('focusout', (event) => {
        $(event.currentTarget).val($(event.currentTarget).val().replace(',', ''));
    });

    login.init();

    if ($('.item-list').hasClass('limit-error')) {
        productUtil.showLimitErrorDialog();
        // Remove limit error from query string to prevent it from showing on page refresh
        if (window.history !== undefined && window.history.replaceState !== undefined) {
            window.history.replaceState({}, document.title, window.location.pathname);
        }
    }
};
